<script>
  import {VIDEO_TEXT} from "../const";
  import Image from "./Image.svelte";
  import BlockGlobal from "./BlockGlobal.svelte";

  export let data, isCollapsed = false;

  function change(val, section) {
    data.style = Object.assign({}, data.style, {[section]: val});
  }

  function onCollapse(collapsed) {
    isCollapsed = collapsed;
  }

  let disable = ['has-link'];
  if (data.type === VIDEO_TEXT) {
    disable.push('fullscreen');
  }


</script>
<Image bind:data={data} disable={disable} onCollapse={onCollapse}/>
<BlockGlobal bind:data={data} isCollapsable={true} isCollapsed={true}/>